import classNames from 'classnames';
import classes from './styles/index.module.scss';
import { ThemeStyle } from '../../../../utils/const';
import { isMobile } from '../../../../utils/device';

export const getItemClasses = ({ theme }) => {
	return classNames(classes.button, {
		[classes.button_dark]: !isMobile && theme === ThemeStyle.Dark,
		[classes.button_light]: !isMobile && theme === ThemeStyle.Light,
	});
};
